(function () {
  'use strict';

  var API_BASE = 'https://adwiz.io';
  var CACHE_KEY = 'loyalty_cache';
  var CACHE_TTL = 5 * 60 * 1000; // 5 minutes
  var SIGNUP_COOKIE = 'loyalty_signed_up';

  var root, panel, headerBtn, headerPts, backdrop, body;
  var customerEmail, customerName, loyaltyToken, isLoggedIn;
  var state = { data: null, panelOpen: false };
  var recentCodes = [];

  // ── Init ──

  function init() {
    root = document.getElementById('loyalty-widget');
    if (!root) return;

    headerBtn = document.querySelector('.js-loyalty-toggle');
    headerPts = document.querySelector('[data-loyalty-header-pts]');
    panel = document.getElementById('loyalty-panel');
    backdrop = root.querySelector('[data-loyalty-backdrop]');
    body = root.querySelector('[data-loyalty-body]');

    if (!headerBtn || !panel) return;

    setPanelHidden(true);

    isLoggedIn = root.dataset.loggedIn === 'true';
    customerEmail = root.dataset.customerEmail || '';
    customerName = root.dataset.customerName || '';
    loyaltyToken = root.dataset.loyaltyToken || '';

    headerBtn.addEventListener('click', togglePanel);
    backdrop.addEventListener('click', closePanel);
    root.querySelector('[data-loyalty-close]').addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.panelOpen) closePanel();
    });

    if (isLoggedIn) {
      loadCustomerData();
    } else {
      renderLoggedOutPanel();
    }
  }

  // ── Panel open/close ──

  function togglePanel() {
    if (state.panelOpen) {
      closePanel();
    } else {
      openPanel();
    }
  }

  function openPanel() {
    state.panelOpen = true;
    panel.classList.add('loyalty-panel--open');
    setPanelHidden(false);
    backdrop.classList.add('loyalty-backdrop--visible');
    headerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    state.panelOpen = false;
    panel.classList.remove('loyalty-panel--open');
    setPanelHidden(true);
    backdrop.classList.remove('loyalty-backdrop--visible');
    headerBtn.setAttribute('aria-expanded', 'false');
    if (!document.getElementById('ReviewFormModal')) {
      document.body.style.overflow = '';
    }
  }

  function setPanelHidden(hidden) {
    panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    panel.inert = hidden;
    if (hidden) {
      panel.setAttribute('inert', '');
    } else {
      panel.removeAttribute('inert');
    }
  }

  // ── Data loading ──

  function loadCustomerData() {
    var cached = getCachedData();
    if (cached) {
      state.data = cached;
      renderPanel(cached);
      updateHeaderPts(cached.customer.points_balance);
    }

    fetchCustomer().then(function (data) {
      if (data) {
        state.data = data;
        setCachedData(data);
        renderPanel(data);
        updateHeaderPts(data.customer.points_balance);
      }
    });
  }

  function fetchCustomer() {
    var url = API_BASE + '/api/loyalty/customer?email=' +
      encodeURIComponent(customerEmail) + '&token=' + encodeURIComponent(loyaltyToken);

    return fetch(url)
      .then(function (res) {
        if (res.status === 404) {
          clearCache();
          renderNotEnrolled();
          updateHeaderPts(null);
          return null;
        }
        if (!res.ok) throw new Error('API error');
        return res.json();
      })
      .catch(function () {
        if (!state.data) {
          renderError();
        }
        return null;
      });
  }

  // ── Rendering: logged-in with data ──

  function renderPanel(data) {
    var c = data.customer;
    var html = '';

    html += '<div class="loyalty-balance">';
    html += '<p class="loyalty-balance__points">' + c.points_balance + '</p>';
    html += '<p class="loyalty-balance__label">Points Balance</p>';
    html += '</div>';

    html += '<div class="loyalty-earn-rate">';
    html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
    html += '<span>Earn <strong>2 points</strong> for every <strong>£1</strong> you spend</span>';
    html += '</div>';

    html += '<p class="loyalty-rewards__heading">Your Rewards</p>';
    html += renderRewards(data.all_rewards, data.available_rewards, c.points_balance);

    html += '<div data-loyalty-codes></div>';

    if (data.recent_transactions && data.recent_transactions.length > 0) {
      html += '<p class="loyalty-history__heading">Recent Activity</p>';
      html += renderHistory(data.recent_transactions);
    }

    body.innerHTML = html;

    var btns = body.querySelectorAll('[data-redeem-id]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', handleRedeem);
    }

    for (var k = 0; k < recentCodes.length; k++) {
      showDiscountCode(recentCodes[k].code, recentCodes[k].name);
    }
  }

  function renderRewards(allRewards, availableRewards, balance) {
    var availableIds = {};
    for (var i = 0; i < availableRewards.length; i++) {
      availableIds[availableRewards[i].id] = true;
    }

    var html = '';
    for (var j = 0; j < allRewards.length; j++) {
      var r = allRewards[j];
      var canAfford = availableIds[r.id] === true;
      var pct = Math.min(100, Math.round((balance / r.points_cost) * 100));

      html += '<div class="loyalty-reward' + (canAfford ? ' loyalty-reward--available' : '') + '">';
      html += '<div class="loyalty-reward__info">';
      html += '<p class="loyalty-reward__name">' + escapeHtml(r.name) + '</p>';
      html += '<p class="loyalty-reward__cost">' + r.points_cost + ' points</p>';

      if (!canAfford) {
        html += '<div class="loyalty-reward__progress">';
        html += '<div class="loyalty-reward__progress-bar" style="width:' + pct + '%"></div>';
        html += '</div>';
      }

      html += '</div>';

      if (canAfford) {
        html += '<button class="loyalty-reward__btn" data-redeem-id="' + r.id + '" data-reward-name="' + escapeHtml(r.name) + '">Redeem</button>';
      } else {
        var needed = r.points_cost - balance;
        html += '<span class="loyalty-reward__btn loyalty-reward__btn--locked">' + needed + ' more</span>';
      }

      html += '</div>';
    }
    return html;
  }

  function renderHistory(txs) {
    var html = '';
    for (var i = 0; i < txs.length; i++) {
      var tx = txs[i];
      var isPositive = tx.points > 0;
      var label = formatReason(tx.type, tx.reason);
      var date = formatDate(tx.created_at);

      html += '<div class="loyalty-tx">';
      html += '<div>';
      html += '<span class="loyalty-tx__reason">' + escapeHtml(label) + '</span>';
      html += '<span class="loyalty-tx__date">' + escapeHtml(date) + '</span>';
      html += '</div>';
      html += '<span class="loyalty-tx__points loyalty-tx__points--' + (isPositive ? 'positive' : 'negative') + '">';
      html += (isPositive ? '+' : '') + tx.points;
      html += '</span>';
      html += '</div>';
    }
    return html;
  }

  // ── Rendering: not enrolled (logged-in but no loyalty account yet) ──

  function renderNotEnrolled() {
    var html = '<div class="loyalty-not-enrolled">';
    html += '<h3 class="loyalty-not-enrolled__heading">Start Earning Rewards</h3>';
    html += '<p class="loyalty-not-enrolled__text">You\'ll automatically earn 2 points for every £1 you spend on your next order.</p>';
    html += '<div class="loyalty-earn-rate">';
    html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
    html += '<span>Earn <strong>2 points</strong> for every <strong>£1</strong> you spend</span>';
    html += '</div>';
    html += '</div>';

    html += '<p class="loyalty-rewards__heading">Reward Tiers</p>';

    body.innerHTML = html;

    fetch(API_BASE + '/api/loyalty/rewards')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.rewards) {
          var rewardsHtml = renderRewards(data.rewards, [], 0);
          var tierContainer = body.querySelector('.loyalty-rewards__heading');
          if (tierContainer) {
            tierContainer.insertAdjacentHTML('afterend', rewardsHtml);
          }
        }
      })
      .catch(function () {});
  }

  // ── Rendering: logged out — signup form inline in panel ──

  function renderLoggedOutPanel() {
    var alreadySignedUp = getCookie(SIGNUP_COOKIE);
    var html = '';

    if (alreadySignedUp) {
      // Already signed up via the panel previously — just show login prompt
      html += '<div class="loyalty-not-enrolled">';
      html += '<h3 class="loyalty-not-enrolled__heading">Welcome Back</h3>';
      html += '<p class="loyalty-not-enrolled__text">You\'ve already signed up for rewards. Log in to see your points and redeem discounts.</p>';
      html += '<a href="/account/login" class="loyalty-panel__cta-btn">Log In</a>';
      html += '</div>';
    } else {
      // Signup form
      html += '<div class="loyalty-not-enrolled">';
      html += '<h3 class="loyalty-not-enrolled__heading">Join & Earn Rewards</h3>';
      html += '<p class="loyalty-not-enrolled__text">Sign up and instantly earn <strong>100 points</strong> — enough for <strong>£3 off</strong> your order.</p>';
      html += '<div class="loyalty-earn-rate">';
      html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
      html += '<span>Earn <strong>2 points</strong> for every <strong>£1</strong> you spend</span>';
      html += '</div>';
      html += '</div>';

      html += '<form class="loyalty-panel__signup" data-loyalty-signup-form>';
      html += '<input type="email" name="email" class="loyalty-panel__input" placeholder="Your email" required autocomplete="email">';
      html += '<input type="text" name="name" class="loyalty-panel__input" placeholder="First name (optional)" autocomplete="given-name">';
      html += '<input type="text" name="website" class="loyalty-panel__honeypot" tabindex="-1" autocomplete="off">';
      html += '<button type="submit" class="loyalty-panel__submit">Join & Get 100 Points</button>';
      html += '<div class="loyalty-panel__signup-msg" data-loyalty-signup-msg></div>';
      html += '</form>';

      html += '<div class="loyalty-divider"></div>';

      html += '<p style="font-size:0.85rem;color:#666;text-align:center">Already have an account? <a href="/account/login" style="color:#000;font-weight:600">Log in</a></p>';
    }

    html += '<p style="font-size:0.8rem;color:#999;text-align:center;margin-top:20px">Unlock discounts from £1 to £20 off</p>';

    body.innerHTML = html;

    // Bind signup form
    var form = body.querySelector('[data-loyalty-signup-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleSignup(form);
      });
    }
  }

  // ── Rendering: error state ──

  function renderError() {
    body.innerHTML = '<div class="loyalty-not-enrolled">' +
      '<p class="loyalty-not-enrolled__text">Unable to load rewards right now. Please try again later.</p>' +
      '</div>';
  }

  // ── Header points badge ──

  function updateHeaderPts(points) {
    if (!headerPts) return;
    if (points !== null && points !== undefined) {
      headerPts.textContent = points;
      headerPts.style.display = '';
    } else {
      headerPts.textContent = '';
      headerPts.style.display = 'none';
    }
  }

  // ── Redeem flow ──

  function handleRedeem(e) {
    var btn = e.currentTarget;
    var rewardId = parseInt(btn.dataset.redeemId, 10);
    var rewardName = btn.dataset.rewardName;

    btn.disabled = true;
    btn.textContent = '...';

    fetch(API_BASE + '/api/loyalty/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: customerEmail,
        reward_id: rewardId,
        token: loyaltyToken
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function (data) {
        recentCodes.push({ code: data.discount_code, name: rewardName });
        if (state.data && typeof data.points_balance === 'number') {
          state.data.customer.points_balance = data.points_balance;
          updateHeaderPts(data.points_balance);
          clearCache();
          loadCustomerData();
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Redeem';
        var msg = (err && err.message) || 'Something went wrong. Please try again.';
        alert(msg);
      });
  }

  function showDiscountCode(code, rewardName) {
    var codesContainer = body.querySelector('[data-loyalty-codes]');
    if (!codesContainer) return;

    var html = '<div class="loyalty-code">';
    html += '<p class="loyalty-code__label">' + escapeHtml(rewardName) + ' redeemed!</p>';
    html += '<p class="loyalty-code__value">' + escapeHtml(code) + '</p>';
    html += '<button class="loyalty-code__copy" data-copy-code="' + escapeHtml(code) + '">Copy Code</button>';
    html += '</div>';

    codesContainer.insertAdjacentHTML('afterbegin', html);

    var copyBtn = codesContainer.querySelector('[data-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy Code'; }, 2000);
        }).catch(function () {
          var codeEl = copyBtn.closest('.loyalty-code').querySelector('.loyalty-code__value');
          if (codeEl) {
            var range = document.createRange();
            range.selectNodeContents(codeEl);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }
          copyBtn.textContent = 'Select & Copy';
          setTimeout(function () { copyBtn.textContent = 'Copy Code'; }, 2000);
        });
      });
    }
  }

  // ── Signup (inline in panel) ──

  function handleSignup(form) {
    var emailInput = form.querySelector('input[name="email"]');
    var nameInput = form.querySelector('input[name="name"]');
    var honeypot = form.querySelector('input[name="website"]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var msgEl = body.querySelector('[data-loyalty-signup-msg]');

    if (honeypot && honeypot.value) return;

    var email = emailInput.value.trim();
    var name = nameInput ? nameInput.value.trim() : '';

    if (!email) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Joining...';
    if (msgEl) {
      msgEl.textContent = '';
      msgEl.className = 'loyalty-panel__signup-msg';
    }

    fetch(API_BASE + '/api/loyalty/signup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        name: name,
        honeypot: honeypot ? honeypot.value : ''
      })
    })
      .then(function (res) {
        if (res.status === 409) {
          if (msgEl) {
            msgEl.textContent = 'You\'re already signed up! Log in to see your points.';
            msgEl.className = 'loyalty-panel__signup-msg loyalty-panel__signup-msg--error';
          }
          submitBtn.disabled = false;
          submitBtn.textContent = 'Join & Get 100 Points';
          return;
        }
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json().then(function (data) {
          setCookie(SIGNUP_COOKIE, '1', 60);
          // Replace form with success message
          var signupArea = body.querySelector('.loyalty-not-enrolled');
          var formEl = body.querySelector('[data-loyalty-signup-form]');
          if (signupArea) {
            signupArea.innerHTML =
              '<div style="text-align:center">' +
              '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom:8px"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
              '<h3 class="loyalty-not-enrolled__heading">Welcome!</h3>' +
              '<p class="loyalty-not-enrolled__text">You\'ve earned <strong>' + data.points_balance + ' points</strong>.</p>' +
              '<p style="font-size:0.85rem;color:#666;margin:8px 0 16px">Create an account to track your rewards and redeem discounts.</p>' +
              '<a href="/account/register" class="loyalty-panel__cta-btn">Create Account</a>' +
              '</div>';
          }
          if (formEl) {
            formEl.remove();
          }
        });
      })
      .catch(function () {
        if (msgEl) {
          msgEl.textContent = 'Something went wrong. Please try again.';
          msgEl.className = 'loyalty-panel__signup-msg loyalty-panel__signup-msg--error';
        }
        submitBtn.disabled = false;
        submitBtn.textContent = 'Join & Get 100 Points';
      });
  }

  // ── localStorage cache ──

  function getCachedData() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > CACHE_TTL) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function setCachedData(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ data: data, ts: Date.now() }));
    } catch (e) {}
  }

  function clearCache() {
    try {
      localStorage.removeItem(CACHE_KEY);
    } catch (e) {}
  }

  // ── Helpers ──

  function formatReason(type, reason) {
    if (type === 'redeem') return 'Redeemed reward';
    if (type === 'refund') return 'Refund adjustment';
    if (type === 'import') return 'Imported balance';
    if (reason === 'signup') return 'Signup bonus';
    if (reason === 'purchase') return 'Purchase';
    return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Points';
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    var day = d.getDate();
    var month = d.getMonth() + 1;
    var year = String(d.getFullYear()).slice(-2);
    return (day < 10 ? '0' : '') + day + '.' + (month < 10 ? '0' : '') + month + '.' + year;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(String(str)));
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  // ── Boot ──

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
